import { Component } from '@verndale/core';
import Axios from 'axios';

import { debounce } from '../helpers';
import styles from '../helpers/snazzymaps';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      navigationList: this.el.querySelector(
        '.interactive-map__navigation-list'
      ),
      navigationItems: [
        ...this.el.querySelectorAll('.interactive-map__navigation-link')
      ],
      mapContainer: this.el.querySelector('.interactive-map__map-inner')
    };

    this.initMap();
    this.loadMapData();
  }

  addListeners() {
    // Handle featured navigation items hover/active state
    this.dom.navigationItems.forEach((navItem, index) => {
      navItem.addEventListener('mouseenter', e =>
        this.handleNavItemHover(e, index)
      );
    });

    window.addEventListener(
      'resize',
      debounce(this.handleresize.bind(this), 200)
    );
  }

  async loadMapData() {
    const { data } = await Axios({
      method: 'GET',
      url: this.el.dataset.endpoint
    });

    this.bounds = new google.maps.LatLngBounds();

    this.defaultLocation = data.defaultLocation;
    this.locations = data.locations;

    if (this.locations.length) {
      this.locations.forEach(location => {
        const navItem = this.dom.navigationItems.find(
          navItem =>
            navItem.dataset.locationId &&
            navItem.dataset.locationId === location.id
        );

        location.marker = new google.maps.Marker({
          position: location.geo,
          map: this.map,
          title: location.name,
          icon: `/public/AspenSnowmassRedesign/images/interactive-map/${location.icon}-tag.svg?i=animate`,
          zIndex: location.icon === 'mountain' ? 2 : 1,
          cursor: navItem ? null : 'default'
        });

        location.infoWindow = new google.maps.InfoWindow({
          content: `<div class="interactive-map__map-info-window">${location.name}</div>`,
          position: location.geo,
          pixelOffset: new google.maps.Size(120, 4),
          disableAutoPan: true
        });

        location.marker.addListener('mouseover', () => {
          console.log(location.infoWindow);

          location.infoWindow.open({
            map: this.map,
            shouldFocus: false
          });
        });

        location.marker.addListener('mouseout', () => {
          location.infoWindow.close();
        });

        this.bounds.extend(location.geo);

        if (navItem) {
          location.marker.addListener('click', () => {
            window.location.href = navItem.querySelector('a').href;
          });
        }
      });

      setTimeout(() => {
        this.map.fitBounds(this.bounds);
        this.defaultLocation.zoom = this.map.zoom;
        this.defaultLocation.geo = this.map.center;
      }, 500);
    } else {
      this.map.setCenter(this.defaultLocation.geo);
      this.map.setZoom(this.defaultLocation.zoom);
    }
  }

  initMap() {
    this.map = new google.maps.Map(this.dom.mapContainer, {
      styles,
      center: { lat: 39.1750214524246, lng: -106.911852329082 },
      zoom: 11,
      disableDefaultUI: true,
      scrollwheel: false,
      draggable: false,
      draggableCursor: 'default'
    });
  }

  handleNavItemHover(e, index) {
    this.dom.navigationItems
      .find(navItem => navItem.classList.contains('active'))
      ?.classList.remove('active');

    e.currentTarget.classList.add('active');
    this.dom.navigationList.classList[index > 0 ? 'add' : 'remove']('active');

    const selectedLocation = this.locations.find(
      location =>
        location.id && location.id === e.currentTarget.dataset.locationId
    );

    this.selectedLocation = selectedLocation;
    this.panZoomToLocation();
  }

  handleresize() {
    this.map.fitBounds(this.bounds);
    this.defaultLocation.zoom = this.map.zoom;
    this.panZoomToLocation();
  }

  panZoomToLocation() {
    if (this.selectedLocation) {
      this.locations.forEach(location => {
        if (
          location.icon === 'mountain' &&
          location.id !== this.selectedLocation.id
        ) {
          location.marker.setOpacity(0);
        } else {
          location.marker.setOpacity(1);
        }
      });
      this.map.setZoom(this.selectedLocation.zoom);
      this.map.panTo(this.selectedLocation.geo);
    } else {
      this.locations.forEach(location => location.marker.setOpacity(1));
      this.map.setZoom(this.defaultLocation.zoom);
      this.map.panTo(this.defaultLocation.geo);
    }
  }
}

export default Module;
